import { ManageAssets } from '@bz/wallet';

export const route: RouteDefinition = {
  preload: () => {
    // return get.getMarketTypeList({sportType: Number(params.sportType)});
  },
  info: {
    dialog: {
      get title() {
        return t('VIEW IN CURRENCY');
      },
      // class: 'p-4 space-y-4'
    },
  },
};

export default ManageAssets;
